import { Injectable } from '@angular/core';
import { TmplAstVariable } from '@angular/compiler';
import { PdfThumbListComponent } from 'src/app/viewer/components/pdfViewer-thumbnails.component';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
 
  constructor() { }
data :any={};

  public getMetadataOCR( datas:any ){
    

    this.data.type_de_document= datas.type_de_document;
    this.data.date=datas.date;
    this.data.montantHt=datas.montantHt;
    this.data.montant_total=datas.montant_total;
    this.data.numero_de_facture=datas.numero_de_facture;
    this.data.tva=datas.tva;

  }
}
